import { useState } from 'react';
import { Row, Col } from 'antd';

const Prices = () => {

  const [isMobile, setIsMobile] = useState(window.innerWidth < 700);
  const [centeredText, setCenteredText] = useState(isMobile ? 'center' : '');

  return (
    <>
      <Row justify="space-around" align="middle" style={{ backgroundColor: '#fff', paddingTop: '40px', paddingBottom: '50px', paddingLeft: '20px', paddingRight: '20px' }}>
        <Col span={24} style={{ paddingBottom: '20px' }}>
          <h2 style={{color: '#2e2f5b', fontSize: '36px', fontWeight: '600', letterSpacing: '5px', textAlign: 'center'}}>
            Cenník
          </h2>
        </Col>
        <Col style={{ paddingTop: '0px', paddingBottom: '20px' }}>
          <p style={{ lineHeight: '25px', textAlign: centeredText}}>
            <b>Cenník služieb platný od 01.01.2026</b>
            <br/><br/>
            <ul>
              <li>kotolňa:&nbsp;52,- Eur/ks</li>
              <li>tepelné čerpadlo:&nbsp;52,- Eur/ks</li>
              <li>fotovoltaika:&nbsp;52,- Eur/ks</li>
              <li>baterka:&nbsp;52,- Eur/ks</li>
              <br/>
              <li>merač Elsys:&nbsp;1,04,- Eur/ks</li>
              <li>merač Zenner:&nbsp;0,26,- Eur/ks</li>
              <li>merač Sharky:&nbsp;2,60,- Eur/ks</li>
              <br/>
              <li>programátorské služby:&nbsp;41,60,- Eur/hodina <br/>
              (Zmeny konfigurácie, úpravy systému v zmysle nových požiadaviek na systém pokiaľ nejde o vadu - incident)
              </li>
              <li>ostatné služby:&nbsp;41,60,- Eur/hodina</li>
            </ul>
            Ceny sú uvedené bez DPH.
          </p>
        </Col>
      </Row>
    </>
  );
}

export default Prices;